import Checkbox from 'apollo-react/components/Checkbox';
import React from 'react';
import { useDispatch } from 'react-redux';

import { useFormSelector } from '../../../custom-hooks';
import { setSingleSelectedId } from '../../actions/bulk-edit-actions';
import { isRecordSelected } from '../../selectors/bulk-edit.selectors';

export const BulkSelectCell = ({ row, formKey }) => {
  const dispatch = useDispatch();
  const isSelected = useFormSelector(isRecordSelected, { id: row[row.PrimaryKeyColumn] });

  const selectClickHandler = () => {
    dispatch(setSingleSelectedId(formKey, row[row.PrimaryKeyColumn]));
  };

  return (
    <div style={{ width: 16, marginTop: -2 }}>
      <Checkbox checked={isSelected} onChange={selectClickHandler} />
    </div>
  );
};
